import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';

export default function OrderCancel(props) {
  const { pDatas, open, handleClose, getDataList, parentClose } = props;
  const { amount } = pDatas;
  const auth = useRecoilValue(authAtom);

  const [cancelReason, setCancelReason] = useState(pDatas?.cancelReason);

  const replaceComma = (number) => (number ? number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') : 0);

  const handleClickCancel = async (e) => {
    const { id } = pDatas;
    if (auth.role !== 'ROLE_ADMIN') {
      await axios
        .patch(`/api/coupon/cancel/${id}`, { cancelReason })
        .then((response) => {
          alert(response.data.message);
          handleClose();
          getDataList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    } else {
      if (window.confirm('해당 주문을 취소하고 구매자에게 주문취소완료 알림 메일을 전송하시겠습니까?')) {
        await axios
          .patch(`/api/coupon/cancel-complete/${id}`, { cancelReason })
          .then((response) => {
            alert(response.data.message);
            getDataList(1);
            handleClose();
            parentClose();
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    }
  };

  useEffect(() => {
    if (open) {
      setCancelReason(null);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">사용권 구매 취소</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'block' }}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableRow>
                <TableCell>사용권 개수</TableCell>
                <TableCell align="right">{pDatas?.quantity} 개</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>결제금액 (부가세 제외)</TableCell>
                <TableCell align="right">{replaceComma(amount)} 원</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>부가세</TableCell>
                <TableCell align="right">{replaceComma(amount * 0.1)} 원</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>결제금액 합계</TableCell>
                <TableCell align="right">{replaceComma(amount + amount * 0.1)} 원</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ color: 'red' }}>환불금액</TableCell>
                <TableCell align="right" sx={{ color: 'red' }}>
                  {replaceComma(amount + amount * 0.1)} 원
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  <TextField placeholder="구매 취소 사유를 입력해주세요." size="small" sx={{ width: '100%' }} multiline rows={2} value={cancelReason} onChange={(e) => setCancelReason(e.target.value)} />
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
          <Typography sx={{ mt: 2, mx: 4 }}>구매를 취소하면 되돌릴 수 없습니다. </Typography>
          <Typography sx={{ mt: 2, mx: 4 }}>사용권 구매를 취소하시겠습니까? </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClickCancel}>
          예
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          아니오
        </Button>
      </DialogActions>
    </Dialog>
  );
}
